/**
 * All fields required for properly accessing and interacting with a deal.
 * Include dspId conditionally based on DSP feature enablement.
 *
 * Current use cases regarding deals:
 *  - Create a room (loading the deal information if a room is going to be created for that deal)
 *  - Updating a room (viewing the deal information and syncing contacts)
 *  - View room as admin/contact
 *  - View room overview (view room's deal info like name, amount, contacts, company)
 */
export const getDealFields = (includeDspId = false): string => `
  id
  amount
  crmId
  ${includeDspId ? 'dspId' : ''}
  currency
  name
  roomId
  roomUuid
  stage
  company {
    id
    name
  }
  contacts {
    id
    email
    firstName
    lastName
    phoneNumber
    company {
      id
      name
    }
  }
`;

/**
 * Default export for backward compatibility (used by other parts of codebase)
 */
export const dealFields = getDealFields(false);

/**
 * Fields required for listing the deals.
 * Include dspId conditionally based on DSP feature enablement.
 *
 * Current use cases regarding deals:
 *  - Deals listing table
 */
export const getDealListingFields = (includeDspId = false): string => `
  id
  amount
  crmId
  ${includeDspId ? 'dspId' : ''}
  currency
  name
  stage
  type
  updatedAt
  company {
    id
    name
  }
  contacts {
    id
    email
    firstName
    lastName
  }
  room {
    uuid
    permissions {
      canEdit
    }
    status
  }
  user {
    id
    firstName
    lastName
  }
`;

/**
 * Default export for backward compatibility (used by other parts of codebase)
 */
export const dealListingFields = getDealListingFields(false);

/**
 * Fields required to display insights regarding deals.
 *
 * Current use cases regarding deals:
 *  - Insights page
 */
export const insightsDealFields = `
  id
  amount
  createdById
  currency
  roomId
  stage
  type
  userId
  room {
    contentIds
  }
`;
